import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Hekima";

const HekimaPhase3 = () => {
  const projectId = 15; // Kept as number per original
  const title = "Hekima Phase 3";

  const mapConfig = {
    minZoom: 3,
    zoom: 4.5,
    bounds: [
      [47.29, -195.85],
      [-1.39, -149.44],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/hekima-gardens-phase-3-nyeri/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSd3Z4R7DdMy_fyI1MdxtK2NVsvDt5uxVuVgFUhiOeJeWMyA_w/viewform"
    />
  );
};

export default HekimaPhase3;
